module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAAGzCI4dAAAAAXNSR0IArs4c6QAAAItJREFUGBlFj60SgkAURq9YtGAj0XgKkkPBpolg4Al5Amw+ipWmCZKcw8wO38y5u/fv29mIiBp29QfuJ7hae5ikSkfyg39GsP2FF1wgbgbkbu3KHTxzGFxx1ESP+Uh4wgCVOKpHAcmYa7TgA5MDygcc1EppN8JmaTNt2FjAwRI+OvhbC2+YQZ2hgWUFR10X9X30ZOoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_cancel1.png
// module id = Pd02
// module chunks = 1